import activeIcon from '../../../assets/images/active-icon.svg'
import completeIcon from '../../../assets/images/complete-icon.svg'
import targetIcon from '../../../assets/images/target-icon.svg'

export enum SidebarItemTitle {
  TestingForFentanyl = 'Testing for Fentanyl',
  GoodSamaritanLaws = 'Good Samaritan Laws',
  YourPolicies = 'Your Policies'
}

const sidebarItems = [
  { value: 1, title: SidebarItemTitle.TestingForFentanyl as string, slot: 'testing-for-fentanyl', icon: completeIcon, webPageUrl: 'https://dopa.ge/testing-fentanyl' },
  { value: 2, title: SidebarItemTitle.GoodSamaritanLaws as string, slot: 'good-samaritan-laws', icon: activeIcon, webPageUrl: 'https://dopa.ge/good-samaritan-overdose' },
  { value: 3, title: SidebarItemTitle.YourPolicies as string, slot: 'your-campus-policies', icon: targetIcon, webPageUrl: '' }
]

export default sidebarItems
